/**
 * JSON-LD Schema 配置
 * 用於 GEO (Generative Engine Optimization) - 讓 AI 模型理解應用程式結構
 */

/**
 * Bentana 組織和應用程式的 JSON-LD Schema
 */
export const bentanaJsonLd = {
  '@context': 'https://schema.org',
  '@type': ['Organization', 'SoftwareApplication'],
  name: 'Bentana',
  url: 'https://bentana.app',
  applicationCategory: 'FinanceApplication',
  operatingSystem: 'Web',
  description:
    'The largest Market Maker and liquidity provider on Polymarket.',
  knowsAbout: [
    'Prediction Markets',
    'Polymarket',
    'Crypto Derivatives',
    'Liquidity Provision'
  ],
  foundingDate: '2024',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    description: 'Free analytics dashboard for Polymarket users'
  },
  potentialAction: {
    '@type': 'InvestAction',
    target: 'https://bentana.app/en/invest',
    name: 'Invest in Bentana Seed+ Round'
  }
}

/**
 * 獲取 JSON-LD Schema 字串
 * @returns JSON-LD Schema 的字串表示
 */
export function getJsonLdString(): string {
  return JSON.stringify(bentanaJsonLd, null, 2)
}

